import scrollIntoViewIfNeeded from '@Ravnur-Inc/helpers/dom/scrollIntoViewIfNeeded';

export function findFirstErrorInDOM(element: Element) {
  return element.querySelector('.error-messages');
}

export function hasErrorInDOM(element: Element) {
  return !!findFirstErrorInDOM(element);
}

export function scrollToFirstErrorInDOM(element: Element = document.body) {
  const el = findFirstErrorInDOM(element);
  if (el instanceof HTMLElement) {
    const parent = el.parentElement;
    if (parent instanceof HTMLLabelElement) {
      scrollIntoViewIfNeeded(parent, true);
    } else {
      scrollIntoViewIfNeeded(el, true);
    }
  }
}
